import {defaultSelectedWarehouse} from "./state";

export function setWarehouses(state, warehouses) {
    state.warehouses = warehouses;

    state.warehouses.map(el => {
        if (!el.city) {
            el.city= {department_id : null}
        }
    })
}

export function setWarehouse(state, warehouse) {
    state.selectedWarehouse = JSON.parse(JSON.stringify(warehouse));
}

export function setActionWarehouses(state, action) {
    state.actionWarehouse = action;
}

export function setSellersByRole(state, data) {
    state.sellersByRole = data;
}

// Establece un valor para departments
export function setDepartments(state, departments) {
    state.departments = departments.map(p => {
      return { value: p.id, label: p.department };
    });
}

export function warehouseError(state, error) {
    state.error = true
    state.errorMessage = error
}

//Establece el valor por defecto de selectedWarehouse
export function resetSelectedWarehouse(state) {
    let id = state.selectedWarehouse.id
    Object.assign(state.selectedWarehouse, defaultSelectedWarehouse())
    if (id) {
        state.selectedWarehouse.id = id
    }
}


 export function setSellers(state,sellers) {
   state.sellers=sellers;
}

export function setCities(state, cities){
    state.cities =cities;
}

export function setPaymentMethods(state,data){
    state.paymentMethods=data;
}

export function setTypeNegotiationPortfolio(state,data){
    state.types_negotiation_portfolio=data;
}
export function setZones(state, zones) {
    state.zones = zones
  }

export function setZonesDespatch(state, zones_despatch) {
  state.zones_despatch = zones_despatch
}

export function setAccounts(state, accounts) {
    state.accounts = accounts
}



// WEBPACK FOOTER //
// ./src/modules/contacts-warehouses/mutations.js